import React from "react";
import ProductCard from "../Card/ProductCard";
import MoreButton from "../Button/MoreButton";
import { motion, Variants } from "framer-motion";
import sheetMetal from "../../assets/sheetMetal.jpg";
import angleIron from "../../assets/angleIron.jpg";
import rectangularHollow from "../../assets/rectangularHollow.jpg";
import squareHollow from "../../assets/squareHollow.jpg";
import squareBar from "../../assets/squareBar.jpg";
import flatIron from "../../assets/flatIron.jpg";
import roundBar from "../../assets/roundBar.jpg";
import roundPipe from "../../assets/roundPipe.jpg";
import uChannal from "../../assets/uChannal.jpg";
import iBeam from "../../assets/iBeam.jpg";
import chequeredPlate from "../../assets/chequeredPlate.jpg";
import LTZ from "../../assets/L.T,Z.jpg";

function OurProducts() {
  const products = [
    {
      title: "Rectangular Hollow Sections (RHS)",
      size: "20×10 mm – 120×80 mm",
      thickness: "0.8 – 4 mm",
      image: rectangularHollow,
    },
    {
      title: "Square Hollow Sections (SHS)",
      size: "10×10 mm – 200×200 mm",
      thickness: "0.8 – 8 mm",
      image: squareHollow,
    },
    {
      title: "Square Bar",
      size: "10×10 mm – 200×200 mm",
      thickness: "0.8 – 8 mm",
      image: squareBar,
    },
    {
      title: "Round Pipe",
      size: "12 mm – 200 mm",
      thickness: "0.6 – 3 mm",
      image: roundPipe,
    },
    {
      title: "Round Bars",
      size: "8 mm – 100 mm",
      thickness: "—",
      image: roundBar,
    },
    {
      title: "Angle Irons",
      size: "20×20 mm – 100×100 mm",
      thickness: "2 – 10 mm",
      image: angleIron,
    },
    {
      title: "Flat Irons",
      size: "10 mm – 100 mm",
      thickness: "8 – 12 mm",
      image: flatIron,
    },
    {
      title: "I Beam",
      size: "40×20 mm – 200×60 mm",
      thickness: "6 mm",
      image: iBeam,
    },
    {
      title: "U-Channels",
      size: "40×20 mm – 200×60 mm",
      thickness: "6 mm",
      image: uChannal,
    },
    {
      title: "Sheet Metals",
      size: "Different sizes available",
      thickness: "0.5 – 40 mm",
      image: sheetMetal,
    },
    {
      title: "Chequered Plates",
      size: "Different sizes available",
      thickness: "1.5 – 3 mm",
      image: chequeredPlate,
    },
    {
      title: "L.T,Z",
      size: "Different sizes available",
      thickness: "1.5 – 3 mm",
      image: LTZ,
    },
  ];

  const containerVariants: Variants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <motion.div
      id="Products-and-Services"
      className="bg-[#F4F4F1] pt-48 pb-12 md:pb-36 px-10 sm:px-20 lg:px-32"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: "some" }}
      variants={containerVariants}
    >
      {/* Header & Button */}
      <motion.div
        className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-24"
        variants={containerVariants}
      >
        <motion.div className="mb-8 sm:mb-0" variants={itemVariants}>
          <motion.div
            className="inter-black text-2xl mb-3.5 text-[#EEB762]"
            variants={itemVariants}
          >
            BUSINESS SEGMENTS
          </motion.div>
          <motion.h3
            className="text-[#1F1F1E] changa-one-regular text-4xl sm:text-6xl"
            variants={itemVariants}
          >
            OUR <br /> Products
          </motion.h3>
        </motion.div>
        {/* <motion.div variants={itemVariants}>
          <MoreButton title="VIEW MORE" />
        </motion.div> */}
      </motion.div>

      {/* Product Cards */}
      <motion.div
        className="flex flex-wrap justify-between"
        variants={containerVariants}
      >
        {products.map((product, idx) => (
          <motion.div
            key={idx}
            className="w-full sm:w-[48%] md:w-[32%] lg:w-[30%]"
            variants={itemVariants}
          >
            <ProductCard
              image={product.image}
              title={product.title}
              size={product.size}
              thickness={product.thickness}
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}

export default OurProducts;
